import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import * as jwt_decode from 'jwt-decode';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import CONSTANTS from '../../app.config';
import { Broadcaster } from './../../../utils/broadcaster.service';

import { User } from './user';

@Injectable()
export class AuthService {

  private loggedIn = new BehaviorSubject<boolean>(false); // {1}

  get isLoggedIn() {
    if (localStorage.getItem('currentUser')) {
      this.loggedIn.next(true);
    } else {
      this.loggedIn.next(false);
    }
    return this.loggedIn.asObservable();
  }

  constructor(
    private router: Router,
    private http: HttpClient,
    private broadcaster: Broadcaster
  ) { }

  login(user: User): Observable<User> {
    const url = `${CONSTANTS.BASE_URL}/auth/login-admin`;

    if (user.username !== '' && user.password !== '') {

      return this.http.post(url, user)
            .pipe(
              map((response: any) => {
                if (response && response.token) {
                  const userData = jwt_decode(response.token);
                  // store username and jwt token in local storage to keep user logged in between page refreshes
                  localStorage.setItem( 'currentUser', JSON.stringify({ token: response.token, userData: userData.user })
                  );
                  this.broadcaster.broadcast('login');
                  this.loggedIn.next(true);
                }

                return user;
              })
            );
    }
  }

  logout() {
    localStorage.removeItem('currentUser');
    this.loggedIn.next(false);
    this.broadcaster.broadcast('logout');
    this.router.navigate(['/login']);
  }
}
